export const PORTAL_BASE_URL = '/digital/helpandsupp';
export const CIAM_TOKEN_VAL_URL = '/v1/token';
